<template>
<span class="psd-parsing-index">
    <el-upload
               action=""
               :disabled="disabled"
               :on-change="onFileChange"
               :show-file-list="false"
               :auto-upload="false" accept=".psd">
    <slot>
      <el-button size="small" type="primary" round >上传多图模板</el-button>
    </slot>
  </el-upload>
  <material-auto-cut v-show="cutImgItems.length"
                     ref="autoCutDomRef"
                     @onAutoCut="onAutoCut"
                     :data="cutImgItems"
                     :t-height="template.json.height"
                     :t-width="template.json.width"></material-auto-cut>
</span>
</template>
<script>
    import {
        empty_template_group,
        module_group_edit,
        img_horizontal,
        img_vertical,
        img_two_direction,
        layer_text,
        layer_img,
        banner_rules,
        template_type_single,
        template_type_multiple
    } from '@/const.js';
    import util from '@/util.js';
    import materialAutoCut from './material-auto-cut'
    import TUtil from "../TUtil";
    import PsdUtil from './PsdUtil'
    export default {
        components: {materialAutoCut},
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            type: {
                type: String, default: template_type_multiple,
            },
            isFree: {
                type: Boolean, default: false
            }
        },
        data() {
            return {
                template: JSON.parse(JSON.stringify(empty_template_group)),
                cutImgItems: []
            }
        },
        methods: {
            _clickUploadBtn(){
                this.$refs.upload.click();
            },
            allowDrop(ev) {
                ev.preventDefault();
            },
            onDrop(evt) {
                // eslint-disable-next-line
                PSD.fromEvent(evt).then((psd) => {
                    this.cutImgItems = [];
                    this.template.defaultUrl = psd.image.toPng().src;
                    let pdsTree = psd.tree();
                    this.template.json.height = pdsTree.height;
                    this.template.json.width = pdsTree.width;
                    this.template.free = this.isFree;
                    this.getImgs(pdsTree);
                    //非自由模板，图片超出模板时，自动剪裁掉，onCompleted 由onAutoCut事件触发
                    if(this.cutImgItems.length > 0){
                        console.log('超出背景元素', this.cutImgItems);
                        this.cutImgs();
                    }else{
                        this.$emit('onCompleted', JSON.parse(JSON.stringify(this.template)));
                    }
                });
            },
            onAutoCut(data){
                this.$emit('onCompleted', JSON.parse(JSON.stringify(this.template)));
            },
            formatterPSDJson(psdJson) {
                this.data = psdJson.children;
            },
            isAutoLineHeight(stylesAutoLeading){
                if(stylesAutoLeading && stylesAutoLeading.length > 0){
                    return stylesAutoLeading[0]
                }
                return null;
            },
            isTextLayer(node){
              return node.layer.typeTool;
            },
            getItem(node) {
                let nodeInfo = node.export();
                if (nodeInfo.width <= 0 || nodeInfo.height <= 0) { // 无效数据
                    return;
                }
                let baseAttr = {
                    opacity: nodeInfo.opacity,
                    width: nodeInfo.width,
                    height: nodeInfo.height,
                    backgroundColor: null,
                    boxShadow: '',
                };
                let commonAttr = {
                    hide: false,
                    key: util.getUUID(),
                    htmlStr: null, // 表格html
                    htmlViewImg: null, //表格截图 url
                    isEditableTable: this.isEditableTable(node.name),
                    allowHide: this.allowHide(node.name),
                    fixed: this.fixed(node.name),
                    disabled: this.isDisabled(node.name),
                    originName: node.name,
                    tagName: this.getTagName(node.name),//banner使用
                }
                let item;
                if (this.isTextLayer(node)) {
                    let tools = node.layer.typeTool();
                    let styles = tools._styles;
                    let fontObj = nodeInfo.text.font;
                    let fontFamilyStr = fontObj.name.substring(0, fontObj.name.length - 1).trim();
                    let letterSpacing = styles.Tracking && styles.Tracking.length > 0 ? styles.Tracking[0] : null;
                    let size = fontObj.sizes && fontObj.sizes.length > 0 ? fontObj.sizes[0] : 12;
                    let lineHeight = styles.Leading && styles.Leading.length > 0 ? styles.Leading[0] : '';
                    let transform = nodeInfo.text.transform;
                    if (transform.xx) {
                        size = parseInt(transform.xx * size);
                        lineHeight = parseInt(transform.xx * lineHeight);
                    }
                    let isAutoLineHeight = this.isAutoLineHeight(styles.AutoLeading);
                    if(isAutoLineHeight || lineHeight === 0){
                        lineHeight = size;
                    }
                    let transformOrigin = 'left top';
                    let text = nodeInfo.text.value || '';
                    //添加新属性后，export-view.vue中联动导出时，需要做部分属性复制
                    let textAlign = fontObj.alignment[0] || 'left';
                    let fontWeight = this.getFontWeight(styles.FauxBold);
                    let colorArr = fontObj.colors[0];
                    colorArr && colorArr.forEach((c, i) => {
                        colorArr[i] = parseInt(colorArr[i]);
                    });
                    let fauxItalic = styles.FauxItalic && styles.FauxItalic.length > 0 ? styles.FauxItalic[0] : false;
                    let fontStyle =  fauxItalic ? 'italic' : 'initial';
                    let textStrokeObj = PsdUtil.getTextBorder(node);
                    item = Object.assign({}, layer_text, {
                        type: 'text',
                        ...commonAttr,
                        name: text,
                        alreadyFixed: true,
                        max: this.getMaxText(node.name),
                        isActionText: this.isActionText(node.name),
                        isMoreRow: true,//this.isMoreRow(text, node.name), //true：使用ps中读取的lineheight,false:使用height做为lineheight
                        lineHeight: lineHeight,// ps中单行文本行高值不对倒致输入多行文本时，间距混乱,配置isMoreRow使用
                        lineHeightScale: null,
                        autoWidth: false,
                        letterSpacing: letterSpacing ? (parseInt(size * (letterSpacing / 1000))) : null,
                        centerHorizontal: textAlign.trim() === 'center' ? true : false,
                        centerVertical: null,
                        textAlign: textAlign,
                        fontSize: size,
                        fontFamily: fontFamilyStr,
                        color: `RGBA(${colorArr.join(',')})`,
                        colorValueList: this.getColorValueList(fontObj.colors), // 一行文本多颜色时，无法区分哪个颜色属于哪些文字,只能读取颜色列表
                        transformOrigin: transformOrigin,
                        textShadow: '',
                        rotate: PsdUtil.getRotate(transform.xy, transform.xx),
                        textDecoration: this.getTextLine(styles),
                        fontWeight,
                        fontStyle,
                        textStrokeObj,
                        ...node.coords,
                        ...baseAttr
                    });
                    if (this.isChineseSymbols(text)) { //末尾有中文符号时，空白宽度没有解析出来，导致宽度偏小，只能粗略扩大
                        let w = Math.abs(parseFloat(size) - 10);
                        item.width += w;
                        item.right += w;
                    }
                    TUtil.fixWidth(item);
                } else {
                    //添加新属性后，export-view.vue中联动导出时，需要做部分属性复制
                    item = Object.assign({}, layer_img, {
                        ...commonAttr,
                        ...node.coords,
                        ...baseAttr,
                        borderRadius: this.getRadius(node.name),
                        isActionBg: this.getActionBg(node.name),
                        isCircle: this.getCircle(node.name),
                        showImg: true, //控制是否用div来显示button样式
                        isBgImg: this.isBgImg(node.name),// 图层组内背景图片
                        isPageBgImg: false,
                        isBgMaterialImg: this.isBgMaterialImg(node.name), // 背景上的素材，可跟随背景移动
                        // isMaterial: this.isReplaceableMaterial(node.name),
                        direction: '', //this.getDirection(node.name),
                        name: node.name,
                        type: 'img',
                        url: node.toPng().src,
                        isGroupMaterial: this.isGroupMaterial(node.name),
                        materialGroup: null,
                    });
                }
                return item;
            },
            getTextLine(styles){
                let {Underline, Strikethrough} = styles;
                let textDecoration = 'none';
                if(Strikethrough && Strikethrough.length > 0 && Strikethrough[0]){
                    textDecoration = 'line-through'
                }
                if(Underline && Underline.length > 0 && Underline[0]){
                    textDecoration = 'underline'
                }
                return textDecoration;
            },
            getFontWeight(boldArray) {
                if (boldArray && boldArray.length > 0) {
                    return boldArray[0] ? 700 : null;
                }
                return null;
            },
            getTagName(name) {
                let flag = banner_rules.imgHorizontalExpansion;
                if (name.indexOf(flag) > -1) {
                    let reg = new RegExp(`${flag}-\\d+`);
                    let arr = name.match(reg);
                    let tagName = arr ? arr[0] : flag;
                    return tagName;
                } else {
                    return '';
                }
            },
            getGroupItemVisible(name){ // 用来排除非模块组项，但又必须定义在模块组内的目录
               return name.indexOf('非模块项') > -1 ? true : null;
            },
            getDirection(name) {
                if (name.indexOf('水平扩展') > -1) {
                    return img_horizontal
                } else if (name.indexOf('垂直扩展') > -1) {
                    return img_vertical
                } else if (name.indexOf('双向扩展') > -1) {
                    return img_two_direction
                }
                return '';
            },
            allowHide(name) {
                return name.indexOf('支持隐藏') > -1
            },
            isDisabled(name) {
                return name.indexOf('禁止操作') > -1
            },
            isGroupMaterial(name) {
                return name.indexOf('支持拼图') > -1
            },
            fixed(name) {
                return name.indexOf('禁止联动') > -1
            },
            getColorValueList(colorList) {
                let set = new Set();
                colorList.forEach((arr) => {
                    set.add(`RGBA(${arr.join(',')})`);
                });
                return Array.from(set);
            },
            getParentItem(treeObj, item, zIndex){
                let obj = {
                    id: `${treeObj.id}_${zIndex}`,
                    zIndex: zIndex,
                    key: util.getUUID(),
                    fixed: false,
                    parentId: treeObj.id,
                    name: item.name,
                    originName: item.name,
                    left: item.left,
                    right: item.right,
                    top: item.top,
                    bottom: item.bottom,
                    width: item.width,
                    height: item.height,
                    copy: false,
                    isModuleGroup: this.isModuleGroup(item.name),
                    edit: module_group_edit.one,
                    type: item.name.indexOf('分组') > -1 ? 'group': '',
                    noGroupItem: this.getGroupItemVisible(item.name),
                    children: []
                }
                return obj;
            },
            setTableData(treeObj, item, zIndex){
                let children = item._children, trList = [], bgItem;
                children.forEach((node) => {
                    if(!node.isGroup() && !this.isTextLayer(node)){
                        bgItem = node;
                    }else{
                        trList.push(node);
                    }
                });
                if (!bgItem) {
                    this.$message.error('请将表格的边框线和背景色合成一张背景图片');
                    return;
                }
                let child = this.setChildByNode(treeObj, bgItem, zIndex);
                let {tableHtml, tableFontFamily} =  this.getTableData(trList, bgItem);
                child.htmlStr = tableHtml;
                child.htmlViewImg = child.url;
                child.fontFamily = tableFontFamily;
            },
            getTextCss(item){
                return [
                    `font-family:${item.fontFamily}`,
                    `font-size: ${item.fontSize}px`,
                    `font-style: ${item.fontStyle}`,
                    `font-weight: ${item.fontWeight || 'normal'}`,
                    `color:${item.color}`,
                ].join(';');
            },
            getTdHeight(tableHeight, rowCount){
                return `${parseInt(tableHeight / rowCount)}px`;
            },
            getTdWidth(tableWidth, tdWidth){
                return `${((tdWidth / tableWidth) * 100).toFixed(2)}%`
            },
            getTableData(children, bgNode){
                let tWidth = bgNode.width, tHeight = bgNode.height;
                let tr, tdList, textItem, htmlList = [], tdSize, tdCss, textCss, temp, rowCount = children.length, fontFamilyList = [];
                children.forEach((node) => {
                    if(node.isGroup()){
                        tr = node;
                        tdList = node._children;
                        htmlList.push('<tr>');
                        tdList.forEach((tdNode) => {
                            if(this.isTextLayer(tdNode)){
                                textItem = this.getItem(tdNode);
                                temp = this.getSize(textItem.originName);
                                tdSize = temp || tdSize;
                                if(tdSize){
                                    tdCss = `width:${this.getTdWidth(tWidth, tdSize.w)};height: ${this.getTdHeight(tHeight, rowCount)}`;
                                }
                                textCss = this.getTextCss(textItem);
                                fontFamilyList.push(textItem.fontFamily);
                                htmlList.push(`<td style="${tdCss}" data-mce-style="${tdCss}"><span style="${textCss}" data-mce-style="${textCss}">${textItem.name}</span></td>`);
                            }
                        });
                        htmlList.push('</tr>')
                    }
                });
                const defTableAttr = `border="1"  style="width: ${tWidth}px;height: ${tHeight}px"`;
                return {
                    tableHtml : `<table class="psd-table" ${defTableAttr}>${htmlList.join('')}</table>`,
                    tableFontFamily: fontFamilyList.join(',')
                }
            },
            deepTree(tree, treeObj, template) {
                let children = tree._children, zIndex = null;
                if (children && children.length > 0) {
                    children.forEach((item, index) => {
                        if (item.visible()) {
                            zIndex = children.length - index;
                            if (item.isGroup()) {
                                if(this.isEditableTable(item.name)){
                                    this.setTableData(treeObj, item, zIndex);
                                }else{
                                    let obj = this.getParentItem(treeObj, item, zIndex);
                                    this.setOriginData(obj);
                                    treeObj.children.push(obj);
                                    this.deepTree(item, obj, template);
                                }
                            } else {
                                try {
                                    let newItem = this.setChildByNode(treeObj, item, zIndex);
                                    if(newItem && newItem.type === 'img' && this.isOverTemplate(template, newItem)){
                                        this.cutImgItems.push(newItem);
                                    }
                                }catch(e){
                                    console.error(e);
                                    this.$message.warning({
                                        duration: 10 * 1000,
                                        showClose: true,
                                        message: `ps图层解析异常，异常图层是"${item.name}"`
                                    });
                                }
                            }
                        }
                    });
                }
            },
            setChildByNode(treeObj, node, zIndex){
                let newItem = this.getItem(node);
                if (newItem) {
                    newItem.id = `${treeObj.id}_${zIndex}`;
                    newItem.parentId = treeObj.id;
                    newItem.zIndex = zIndex;
                    newItem.copy = false;
                    treeObj.children.push(newItem);
                    this.setOriginData(newItem);
                }
                return newItem;
            },
            isOverTemplate(treeObj, item) {
                let {width, height, left, top, right, bottom} = item;
                let tw = treeObj.width, th = treeObj.height;
                let overTemplate = width > tw || width > th || left < 0 || top < 0 || right > tw || bottom > th;
                return overTemplate;
            },
            setOriginData(obj) {
                obj.originData = {
                    left: obj.left,
                    top: obj.top,
                    height: obj.height,
                    width: obj.width
                }
            },
            getImgs(psdTree) {
                /**
                 * reverse(true/false) 图层顺序
                 * true: 和ps顺序一致
                 * false/null/undefined: 和ps顺序相反，需要在编辑面板中反序且修改zIndex值
                 * 通过解析的psd数组中index 做为zIndex, 但ps中的index是反着的，值越小，显示在最上面
                 * 前期不需要树结构，解析的数组都会reverse下，现在需要树目录，且和ps中一致
                 */
                let treeObj = {
                    id: '1',
                    key: util.getUUID(),
                    name: this.template.name,
                    reverse: true,
                    width: psdTree.width,
                    height: psdTree.height,
                    backgroundColor: '',
                    defaultTextColors: '',
                    extensionImg: {
                        url: '',
                        width: null,
                        height: null
                    },
                    children: []
                };
                this.deepTree(psdTree, treeObj, treeObj);
                this.stop = null;
                this.setTemplateBg(treeObj);
                this.template.widthHeight = `${treeObj.width}x${treeObj.height}`;
                Object.assign(this.template.json, treeObj);
            },
            cutImgs(){
                 this.$nextTick(() => {
                     this.$refs.autoCutDomRef._run();
                 })
            },
            setTemplateBg(treeObj) {
                if(this.stop){
                    return;
                }
                let children = treeObj.children;
                if (children && children.length > 0) {
                    let lastLayer = children[children.length - 1];
                    if (lastLayer.children) { //取最后一个图层中的背景元素为模板背景
                        this.setTemplateBg(lastLayer);
                    } else {
                        lastLayer.isPageBgImg = this.isPageBgImg(lastLayer.name);
                        this.stop = lastLayer.isPageBgImg ? true : false;
                    }
                }
            },
            isChineseSymbols(name) {
                let lastStr = name.slice(name.length - 1, name.length);
                //验证是否是中文
                let pattern = new RegExp("[\u4E00-\u9FA5]+");
                if (pattern.test(lastStr)) {
                    return false;
                }
                //验证是否是英文
                let pattern2 = new RegExp("[A-Za-z]+");
                if (pattern2.test(lastStr)) {
                    return false;
                }
                //验证是否是数字
                let pattern3 = new RegExp("[0-9]+");
                if (pattern3.test(lastStr)) {
                    return false;
                }
                return true;
            },
            isMoreRow(text, name) {
                //图层中的换行解析出来是空格，只要是在文本中间的当换行处理
                let hasEnter = text.trim().indexOf(' ') > - 1;
                return hasEnter || name.indexOf('(多行)') > -1 || name.indexOf('（多行）') > -1;
            },
            isBgImg(name) {
                if (this.isBgMaterialImg(name) || this.getActionBg(name)) {
                    return false;
                }
                if (this.type === template_type_single) { // banner使用isBgImg做为模块背景字段,通过setTemplateBg设置
                    return false
                }
                return name.indexOf('背景') > -1;
            },
            isPageBgImg(name) {
                return name === '背景';
            },
            isBgMaterialImg(name) {
                return name.indexOf('背景素材') > -1;
            },
            // isReplaceableMaterial(name) {
            //     return name.indexOf('素材') > -1
            // },
            isActionText(name) {
                return name.indexOf('行动点文案') > -1
            },
            getActionBg(name) {
                return name.indexOf('行动点背景') > -1;
            },
            isModuleGroup(name) {
                return name.indexOf('模块组') > -1;
            },
            getRadius(name) {
                let arr = name.match(/圆角-\d+/);
                if (arr && arr.length > 0) {
                    let numStr = arr[0].split('-')[1];
                    return parseInt(numStr);
                }
                return null;
            },
            getCircle(name) {
                return name.indexOf('圆形') > -1;
            },
            isMoveByText(name) {
                return name.indexOf('图文联动组') > -1;
            },
            isEditableTable(name) {
                return name.indexOf('表格') > -1;
            },
            getMaxText(name) {
                let arr = name.match(/max-\d+/);
                if (arr && arr.length > 0) {
                    let numStr = arr[0].split('-')[1];
                    return parseInt(numStr);
                } else {
                    return null;
                }
            },
            getSize(name){
               let arr =  name.match(/\((.+?)\)/), size = null;
               if(arr && arr.length > 1 && arr[1].indexOf('x') > -1){
                   let sArr = arr[1].split('x');
                   size =  {w: +sArr[0], h: +sArr[1]};
               }
               return size;
            },
            onFileChange(file) {
                this.$emit('onFileChange');
                requestAnimationFrame(() => {
                    this.template.name = file.name.substring(0, file.name.lastIndexOf('.'));
                    this.onDrop({
                        dataTransfer: {
                            files: [file.raw]
                        }
                    });
                })
            },
        }
    }
</script>
<style lang="scss">
</style>